<!--
@component
SchedulePage

Route page component.
-->

<script lang="ts">
  import Page from '$lib/components/SchedulePage/index.svelte';

  import { appState } from '$lib/stores/index.svelte';

  import SEO from '$lib/components/common/SEO/SEO.svelte';
  import parseSeo from '$utils/parseSeo';

  let { data } = $props();

  const content = $derived(data.content);
  const seo = $derived(parseSeo(content, 'schedule-seo'));
</script>

<SEO {seo} />

<Page data={appState.optaData} />
